import MenuUserAvatar from './MenuUserAvatar.vue'
export default MenuUserAvatar
